import { Popover, TextField, Button, Typography, Tooltip } from '@material-ui/core';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import { Response } from 'node-fetch';
import React, { useState } from 'react';
import styled from 'styled-components';
import { uppercaseIdg } from '@mummssoftware/utils/constants';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import { ActionIcon } from '../ActionIcon';
import defaults from '../translations/en.json';
const PopoverContainer = styled.div.withConfig({
  displayName: "AdHocIDGButton__PopoverContainer",
  componentId: "j5uejv-0"
})(["padding:12px;min-width:280px;max-width:320px;display:flex;flex-direction:column;gap:10px;"]);
const TitleButton = styled(Button).withConfig({
  displayName: "AdHocIDGButton__TitleButton",
  componentId: "j5uejv-1"
})(["&&{border:1px solid;}"]);

const submitAdHocIDG = (pim, observation, details, noteData, agency) => pim.addPatientToAdHocMeeting(details, agency).then(res => {
  if (!(res instanceof Response)) {
    return observation.saveProgressNote(noteData, agency, 'POST', 'false').then(() => res);
  }

  return null;
});

export const AdHocIDGButton = ({
  pim,
  observation,
  patient,
  currentUser,
  agency,
  hide,
  onAddedToAdHocAgenda
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'adhoc-idg-popover' : undefined;

  if (hide) {
    return null;
  }

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
    setReason('');
    setStatusMessage(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setReason('');
    setStatusMessage(null);
  };

  const handleSubmit = () => {
    var _currentUser$personNu, _currentUser$personNu2, _currentUser$userId, _patient$siteId;

    if (!reason.trim()) return;
    setSubmitting(true);
    const details = {
      patientNumber: patient.patientNumber,
      reasonForAdhocMeeting: reason.trim()
    };
    const noteData = {
      note: `Added to AdHoc: ${reason.trim()}`,
      noteddatetime: formatPostDate(new Date()),
      patientnumber: patient.patientNumber,
      personnumber: (_currentUser$personNu = (_currentUser$personNu2 = currentUser.personNumber) === null || _currentUser$personNu2 === void 0 ? void 0 : _currentUser$personNu2.toString()) !== null && _currentUser$personNu !== void 0 ? _currentUser$personNu : '',
      personid: (_currentUser$userId = currentUser.userId) === null || _currentUser$userId === void 0 ? void 0 : _currentUser$userId.toString(),
      siteid: (_patient$siteId = patient.siteId) === null || _patient$siteId === void 0 ? void 0 : _patient$siteId.toString(),
      patientprogressnoteentitydto: [{
        entitykey: '-1',
        entitytypeshortname: uppercaseIdg,
        entityname: '',
        id: ''
      }]
    };
    submitAdHocIDG(pim, observation, details, noteData, agency).then(result => {
      if (result) {
        if (result.httpstatuscode === 201 || result.httpstatuscode === 202) {
          if (onAddedToAdHocAgenda) {
            onAddedToAdHocAgenda();
          }
        }

        setStatusMessage(result.httpstatuscode === 202 ? defaults.adHocIDGAlreadyPresent : defaults.adHocIDGSuccess);
      } else {
        setStatusMessage(defaults.adHocIDGError);
      }
    }).catch(() => setStatusMessage(defaults.adHocIDGError)).finally(() => setSubmitting(false));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: defaults.adHocIDGTooltip,
    placement: "bottom"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ActionIcon, {
    "aria-describedby": id,
    Icon: GroupAddIcon,
    onClick: handleOpen,
    style: {
      margin: 0
    }
  }))), /*#__PURE__*/React.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(PopoverContainer, null, /*#__PURE__*/React.createElement(TitleButton, {
    color: "primary",
    size: "small",
    onClick: handleSubmit,
    disabled: !reason.trim() || submitting
  }, defaults.adHocIDGButton), statusMessage ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, statusMessage) : /*#__PURE__*/React.createElement(TextField, {
    label: defaults.adHocIDGReason,
    multiline: true,
    minRows: 3,
    fullWidth: true,
    value: reason,
    onChange: e => setReason(e.target.value),
    inputProps: {
      style: {
        fontSize: '13px'
      }
    },
    autoFocus: true
  }))));
};